<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <tabela
          :items="items"
          :loading="loading"
          @rechargeTable="getAll()"
          @switchProcessamentosExpirados="((processamentosExpirados = $event), getAll())"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import MovimentacaoBlindadaService from '@/services/MovimentacaoBlindadaService';
  import pusherMixins from '@/mixins/pusherMixins';
  import tourMixins from '@/mixins/tourMixins';

  export default {
    components: {
      Tabela: () => import('@/components/movimentacaoBlindada/Tabela.vue')
    },
    mixins: [pusherMixins, tourMixins],

    data: () => ({
      items: [],
      loading: false,
      processamentosExpirados: false,
      arrTour: [
        {
          element: '#btn-nova-movimentacao-blindada',
          intro: 'Clicando neste botão você poderá criar novas movimentações da blindada.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#movimentacao-blindada-search',
          intro: 'Neste campo você poderá pesquisar por movimentações da blindada já existentes.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#action-download-movimentacao-blindada',
          intro: 'Clicando neste ícone você poderá fazer o download em .XLSX do resultado de sua movimentação da blindada.',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#action-edit-movimentacao-blindada',
          intro: 'Clicando neste ícone você poderá editar sua movimentação da blindada.',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#action-more-movimentacao-blindada',
          intro:
            'Aqui você acessa outras opções para sua movimentação da blindada, como ver mais detalhes, executá-lo novamente, duplica-ló ou deletá-lo.',
          scrollTo: 'tooltip',
          position: 'left'
        }
      ]
    }),

    mounted() {
      this.subscribe();
      this.getAll();
    },

    methods: {
      subscribe() {
        this.pusherChannel.bind('reload-pag-movimentacao-blindada', () => {
          this.getAll();
        });
      },

      getAll() {
        this.loading = true;

        MovimentacaoBlindadaService.getAll(this.processamentosExpirados)
          .then((response) => (this.items = response.data.data))
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar movimentações da blindada.', '', { position: 'topRight' });
          })
          .finally(() => {
            this.loading = false;
            this.iniciarTourPagina();
          });
      },
      iniciarTourPagina() {
        if (this.tourFuncCalled) return;
        let arrTourFormatted = this.item.length ? this.arrTour : this.arrTour.splice(0, 2);
        this.iniciarTour(arrTourFormatted);
      }
    }
  };
</script>